/** 平台创建的排班-时刻表-值班司机-编辑模式 */
<template>
  <div id="schedulingPlatformTimeDriverForm" v-if="schedulingTime">
    <div class="schedulingPlatformTimeDriverForm-head">
      <span>{{ getWeek(schedulingTime) }} {{ schedulingTime | filterTime("MM-DD") }} 值班车辆 </span>
      <span class="util-remark">当天的订单将按派单顺序，自动派出</span>
    </div>

    <el-table :data="vehicleInfo" border style="width: 100%">
      <el-table-column prop="sort" label="派单顺序">
      </el-table-column>
      <el-table-column prop="licenseNo" label="车辆号牌">
        <template slot-scope="{row}">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>
      </el-table-column>
      <el-table-column prop="driverName" label="值班司机"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{$index,row}">
          <el-button type="text" @click="deleteFn($index,row)">删除</el-button>
          <el-tooltip content="下移" placement="top" v-if="$index!=vehicleInfo.length-1" class="move-arrow">
            <i class="iconfont icon-move-down" @click="moveFn($index, 'down')"></i>
          </el-tooltip>
          <el-tooltip content="上移" placement="top" v-if="$index !== 0" class="move-arrow">
            <i class="iconfont icon-move-up" @click="moveFn($index, 'up')"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!--如果日期为当天，或当前为查看页，或班次条数已经15条，则隐藏【添加车辆】-->
    <div class="add" @click="addFn" v-if="vehicleInfo.length < 100">
      <i class="el-icon-plus"></i>添加车辆
    </div>

    <schedulingVehicle @confirm="vehicleConfirm" :line="lineInfo" :multiple="lineInfo.schedulingType === 2" :lineOId="lineInfo.organizationId" :drivers.sync="vehicleInfo" :visible.sync="schedulingVehicleShow" />

  </div>
</template>

<script>
export default {
  name: "schedulingPlatformTimeDriverForm",
  components: {
    schedulingVehicle: () => import("./schedulingVehicle.vue"),
  },
  props: ['lineInfo', 'dutyDrivers'],
  data() {
    return {
      schedulingVehicleShow: false,
      dutyDriversData: null,
      schedulingTime: null,
      vehicleInfo: []
    }
  },
  watch: {
    dutyDrivers: {
      handler(val) {
        if (val) {
          this.dutyDriversData = val;
          this.schedulingTime = val.schedulingTime;
          this.vehicleInfo = val.vehicleInfo;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {

  },
  mounted() { },
  methods: {

    /* 添加车辆 */
    addFn() {
      this.schedulingVehicleShow = true;
    },


    async vehicleConfirm(result) {
      let vehicleInfo = [];
      result.map((item, index) => {
        if (!item.sort) {
          vehicleInfo.push({
            sort: index + 1,
            driverId: item.driverId,
            driverName: item.driverName,
            vehicleId: item.vehicleId,
            licenseNo: item.licenseNo
          });
        }
      })

      // if (this.dutyDriversData.isNew) {
      this.$emit('isNewVehicleInfoUpdate', { schedulingTime: this.schedulingTime, vehicleInfo: this.vehicleInfo.concat(vehicleInfo) });
      // } else {
      //   let url = "/api/v1/manage/line/scheduling/line/vehicle";
      //   let data = await this.$axios.post(url, { lineId: this.lineInfo.id, schedulingTime: this.schedulingTime, vehicleJson: JSON.stringify(vehicleInfo) });
      //   if (data && data.code == 1) {
      //     this.$message.success('车辆已添加');
      //     this.$emit('getDutyDriversDataByTime', this.schedulingTime);
      //   }
      // }
    },

    /* 删除车辆 */
    deleteFn(index, row) {
      this.$confirm(`确定删除吗？`, "提示").then(async () => {
        // if (this.dutyDriversData.isNew) {
        this.vehicleInfo.splice(index, 1);
        this.$emit('isNewVehicleInfoUpdate', { schedulingTime: this.schedulingTime, vehicleInfo: this.vehicleInfo });
        // } else {
        //   let url = "/api/v1/manage/line/scheduling/line/vehicle/" + row.lineVehicleId;
        //   let data = await this.$axios.delete(url);
        //   if (data && data.code == 1) {
        //     this.$message.success('车辆已删除');
        //     this.$emit('getDutyDriversDataByTime', this.schedulingTime);
        //   }
        // }
      })
    },

    // 上下移动
    async moveFn(index, type) {
      if (type == "down") {
        [this.vehicleInfo[index].sort, this.vehicleInfo[index + 1].sort] = [this.vehicleInfo[index + 1].sort, this.vehicleInfo[index].sort];
        [this.vehicleInfo[index], this.vehicleInfo[index + 1]] = [this.vehicleInfo[index + 1], this.vehicleInfo[index]];
      } else if (type == "up") {
        [this.vehicleInfo[index - 1].sort, this.vehicleInfo[index].sort] = [this.vehicleInfo[index].sort, this.vehicleInfo[index - 1].sort];
        [this.vehicleInfo[index - 1], this.vehicleInfo[index]] = [this.vehicleInfo[index], this.vehicleInfo[index - 1]];
      }

      // if (this.dutyDriversData.isNew) {
      this.$emit('isNewVehicleInfoUpdate', { schedulingTime: this.schedulingTime, vehicleInfo: this.vehicleInfo });
      this.vehicleInfo.push({});
      this.vehicleInfo.pop();
      // } else {
      //   let params = this.vehicleInfo.map((item, index) => {
      //     return {
      //       id: item.lineVehicleId,
      //       sort: index + 1
      //     }
      //   })

      //   let url = "/api/v1/manage/line/scheduling/line/vehicle/sort";
      //   let data = await this.$axios.post(url, { sort: JSON.stringify(params) });
      //   if (data && data.code == 1) {
      //     this.$message.success('操作成功');
      //     this.$emit('getDutyDriversDataByTime', this.schedulingTime);
      //   } else {
      //     if (type == "down") {
      //       [this.vehicleInfo[index], this.vehicleInfo[index + 1]] = [this.vehicleInfo[index + 1], this.vehicleInfo[index]];
      //     } else if (type == "up") {
      //       [this.vehicleInfo[index - 1], this.vehicleInfo[index]] = [this.vehicleInfo[index], this.vehicleInfo[index - 1]];
      //     }
      //   }
      // }
    },

    /* 获取日期 */
    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },
  },
};
</script>

<style lang="less" scoped>
#schedulingPlatformTimeDriverForm {
  .schedulingPlatformTimeDriverForm-head {
    height: 39px;
    padding-bottom: 10px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-bottom: 1px rgb(221, 221, 221) solid;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      &:nth-child(1) {
        font-size: 20px;
        font-weight: bold;
      }
      &:nth-child(2) {
        color: #666;
      }
    }
  }

  .move-arrow {
    color: #2b77ff;
    margin-left: 15px;
    cursor: pointer;
    position: relative;
    top: 2px;
  }

  .add {
    margin-top: 12px;
    width: calc(100% - 2px);
    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }
}
</style>
